import { jsx } from "react/jsx-runtime";
import { isDev } from "@workwave-tidal/core/base";
import { createContext, useContext } from "react";
import { createEmptyFormState } from "./createEmptyFormState.js";
const __DEV__ = isDev();
const formContext = createContext(createEmptyFormState());
function FormRoot(props) {
  const { children, formState } = props;
  return /* @__PURE__ */ jsx(formContext.Provider, { value: formState, children });
}
function useFormInternalContext() {
  const ctx = useContext(formContext);
  if (__DEV__ && ctx.store.id === "_____defaultEmptyState_____") {
    throw new Error(`You cannot use a FormState Context without mounting a FormRoot component as an ancestor.`);
  }
  return ctx;
}
export {
  FormRoot,
  useFormInternalContext
};
//# sourceMappingURL=formContext.js.map
